<script lang="ts">
    import showController from '../../../controller/ShowController'
    import {ShowType, IProduct} from '../../../types/Show'
    import { createEventDispatcher } from 'svelte'
    import { currentProductStore as currentProduct, productsStore as products, showStore as show } from '../../../stores'

    // events
    
    const dispatch = createEventDispatcher()
    const selectProduct = (productId: string) => {
        dispatch('productSelected', {
            productId: productId
        })
        showController().selectCurrentProduct(productId)
    }
    
    // helpers
    
    const itemClasses = (product: IProduct, currentProduct: IProduct|null): string => {
        let classes = ['bietagent-item-list-item']
        if(product.productId === currentProduct?.productId) {
            classes.push('selected')
        }
        if(!product.available) {
            classes.push('sold-out')
        }
        return classes.join(' ')
    }
</script>

{#if $show.meta?.type === ShowType.MultiProduct || $show.meta?.type === ShowType.MultiCreation}
    <div class="multiproduct-show multiproduct-show-products">
        <ul class="bietagent-item-list multiproduct-show-products-list">
            {#each $products as product}
                <li class="{itemClasses(product, $currentProduct)}" 
                    on:click="{() => selectProduct(product.productId)}"
                >
                    <span>
                        <img draggable="false" src="{product.image.size80}" alt="{product.name}">
                    </span>
                </li>
            {/each}
        </ul>
    </div>
{/if}